import http from "./httpService";
import urlConstant from "../constants/url-constants";

export async function RegisterPartRequest(Requester, CompanyName, MobileNumber, CompanyPhone, ModelDetail, RequestDescription, provinceId, province , CaptchaRef) {
    const { data: result } = await http.post(urlConstant.getRegisterPartRequestEndpoint(), {
        Requester,
        CompanyName,
        MobileNumber,
        CompanyPhone,
        ModelDetail,
        province,
        provinceId,
        RequestDescription,
        CaptchaRef
    }, http.getPublicConfig());
    return result;
}

export default {
    RegisterPartRequest
};

